// extracted by mini-css-extract-plugin
module.exports = {"reply_to_container":"ReplyTo_reply_to_container__2HOBh","primary_action_container":"ReplyTo_primary_action_container__2I8PL"};